import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=36af4104&scoped=true&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&id=36af4104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af4104",
  null
  
)

export default component.exports